var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comment" }, [
    _c("div", { staticClass: "comment__top" }, [
      _c("div", { staticClass: "comment__name" }, [
        _vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "comment__date" }, [
        _vm._v("\n            " + _vm._s(_vm.data.date) + "\n        ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "comment__comment" }, [
      _vm._v("\n        " + _vm._s(_vm.data.comment) + "\n    ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }